<template>
  <div class="quote-trust">
    <ul class="quote-trust-grid">
      <li class="quote-trust-item">
        <svg viewBox="0 0 24 24" aria-hidden="true">
          <circle cx="12" cy="12" r="9" />
          <path d="M12 7v5l3 2" />
        </svg>
        <div>
          <div class="quote-trust-title">24h claim assessment</div>
          <div class="quote-trust-sub">Our Claims Promise</div>
        </div>
      </li>
      <li class="quote-trust-item">
        <svg viewBox="0 0 24 24" aria-hidden="true">
          <circle cx="12" cy="8" r="4" />
          <path d="M4 21c0-4.4 3.6-7 8-7s8 2.6 8 7" />
        </svg>
        <div>
          <div class="quote-trust-title">50,000+ riders covered</div>
          <div class="quote-trust-sub">Since 2014</div>
        </div>
      </li>
      <li class="quote-trust-item">
        <svg viewBox="0 0 24 24" aria-hidden="true">
          <path d="M3 12V4h8l10 10-8 8L3 12z" />
          <circle cx="7.5" cy="8.5" r="1.5" />
        </svg>
        <div>
          <div class="quote-trust-title">Price match promise</div>
          <div class="quote-trust-sub">We match cheaper quotes</div>
        </div>
      </li>
      <li class="quote-trust-item">
        <svg viewBox="0 0 24 24" aria-hidden="true">
          <rect x="5" y="11" width="14" height="10" rx="2" />
          <path d="M8 11V8a4 4 0 0 1 8 0v3" />
        </svg>
        <div>
          <div class="quote-trust-title">Secure checkout</div>
          <div class="quote-trust-sub">Encrypted &amp; verified</div>
        </div>
      </li>
    </ul>
    <SecuritySeal small class="quote-trust-seal" />
  </div>
</template>

<script>
// Trust badges under the quick-quote form. Every line here must be something
// we can stand behind — no ratings (the review feed is switched off) and
// no cipher-strength claims (the live site negotiates AES-128).
import SecuritySeal from '@/components/SecuritySeal'

export default {
  name: 'QuoteTrustPanel',
  components: { SecuritySeal },
}
</script>

<style lang="scss" scoped>
.quote-trust {
  display: flex;
  align-items: center;
  gap: 10px;
  margin-top: 10px;
  padding: 8px 10px;
  background: $ps-surface;
  border-radius: $ps-radius-md;
}

.quote-trust-grid {
  flex: 1;
  min-width: 0;
  display: grid;
  grid-template-columns: 1fr;
  gap: 6px 8px;
  margin: 0;
  padding: 0;
  list-style: none;
  @media (min-width: 360px) {
    grid-template-columns: 1fr 1fr;
  }
}

.quote-trust-item {
  min-width: 0;
  display: flex;
  align-items: flex-start;
  gap: 6px;
  text-align: left;

  svg {
    flex: none;
    width: 14px;
    height: 14px;
    margin-top: 1px;
    fill: none;
    stroke: $ps-green;
    stroke-width: 1.6;
    stroke-linecap: round;
    stroke-linejoin: round;
  }

  > div {
    min-width: 0;
  }
}

.quote-trust-title {
  font-family: $family-bold;
  font-size: 12px;
  line-height: 1.2;
  color: $ps-ink;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

.quote-trust-sub {
  font-family: $family-regular;
  font-size: 10px;
  line-height: 1.2;
  color: $ps-muted;
}

.quote-trust-seal {
  flex: none;
}

// Too narrow for the seal alongside two columns: seal drops underneath.
@media (max-width: 420px) {
  .quote-trust {
    flex-direction: column;
    gap: 10px;
  }
}
</style>
